import {useTranslation} from 'react-i18next';
import {useDemographicsStyles} from '../admitStyles';
import AgyleAccordion from '../../../components/ui/accordion/agyleAccordion';
import Grid from '@mui/material/Grid';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import React from 'react';

export default function AdultAccordion({ admit, handleChangeInput, isChild, setAdmit, checkDisabled }) {
  const { t } = useTranslation();
  const classes = useDemographicsStyles();

  return (
      <AgyleAccordion expanded label={t('Other patient information')}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <AgyleTextField
              size={"large"}
              multiline
              noBorder={false}
              disabled={checkDisabled()}
              variant="outlined"
              label={"Employer name"}
              className={classes.formControl}
              value={admit.employerName}
              fullWidth
              name={"employerName"}
              onChange={handleChangeInput}
              error={!isChild() && !admit.employerName}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AgyleTextField
              size={"large"}
              noBorder={false}
              disabled={checkDisabled()}
              variant="outlined"
              label={"Employer postal code"}
              className={classes.formControl}
              value={admit.employerPostalCode}
              fullWidth
              name={"employerPostalCode"}
              onChange={handleChangeInput}
              error={!isChild() && !admit.employerPostalCode}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AgyleTextField
              size={"large"}
              multiline
              noBorder={false}
              disabled={checkDisabled()}
              variant="outlined"
              label={"Employer address"}
              className={classes.formControl}
              name={"employerAddress"}
              value={admit.employerAddress}
              fullWidth
              onChange={handleChangeInput}
              error={!isChild() && !admit.schoolAddress}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </AgyleAccordion>
  );
};
